exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".lbaKeyValuePairs_list{margin:1rem 0}.lbaKeyValuePairs_uiSelect{display:inline-block;width:30rem;margin:0 1rem 0 0}.lbaKeyValuePairs_uiSelect .form-control{width:100%}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaKeyValuePair/src/components/lbaKeyValuePair/lbaKeyValuePairs.scss"],"names":[],"mappings":"AAAA,uBACE,aAAc,CACf,2BAGC,qBACA,YACA,iBAAkB,CAHpB,yCAMI,UAAW,CACZ","file":"lbaKeyValuePairs.scss","sourcesContent":[".lbaKeyValuePairs_list {\r\n  margin: 1rem 0;\r\n}\r\n\r\n.lbaKeyValuePairs_uiSelect {\r\n  display: inline-block;\r\n  width: 30rem;\r\n  margin: 0 1rem 0 0;\r\n\r\n  .form-control {\r\n    width: 100%;\r\n  }\r\n}"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/sass-loader?sourceMap!./src/components/lbaKeyValuePair/lbaKeyValuePairs.scss
// module id = 248
// module chunks = 0